import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube } from "lucide-react";
import { LOGO_URL } from "@/lib/api";
import { usePublicSettings } from "@/lib/settings";

export default function Footer() {
  const { settings } = usePublicSettings();
  const contact = settings?.contact || {};
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="border-t border-[#27272A] bg-[#09090B] mt-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <img src={LOGO_URL} alt="ABE" className="h-10 w-auto logo-invert mb-4" />
          <div className="flex gap-3 mt-4">
            {contact.instagram && (
              <a href={contact.instagram} target="_blank" rel="noreferrer" data-testid="social-instagram" className="text-zinc-400 hover:text-[#D4AF37]"><Instagram size={20} /></a>
            )}
            {contact.facebook && (
              <a href={contact.facebook} target="_blank" rel="noreferrer" data-testid="social-facebook" className="text-zinc-400 hover:text-[#D4AF37]"><Facebook size={20} /></a>
            )}
            {contact.youtube && (
              <a href={contact.youtube} target="_blank" rel="noreferrer" data-testid="social-youtube" className="text-zinc-400 hover:text-[#D4AF37]"><Youtube size={20} /></a>
            )}
          </div>
        </div>

        <div>
          <h4 className="font-oswald text-xs font-bold tracking-widest text-[#D4AF37] uppercase mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><Link to="/" className="hover:text-white">Home</Link></li>
            <li><Link to="/events" className="hover:text-white">Events</Link></li>
            <li><Link to="/venues" className="hover:text-white">Venues</Link></li>
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-oswald text-xs font-bold tracking-widest text-[#D4AF37] uppercase mb-4">Support</h4>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><Link to="/legal/refund" className="hover:text-white">Refund Policy</Link></li>
            <li><Link to="/legal/terms" className="hover:text-white">Terms</Link></li>
            <li><Link to="/legal/privacy" className="hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/admin/login" className="hover:text-white">Staff Login</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-oswald text-xs font-bold tracking-widest text-[#D4AF37] uppercase mb-4">Huntsville, AL</h4>
          <p className="text-sm text-zinc-400">{contact.address || "Huntsville, AL"}</p>
          {contact.email && <a href={`mailto:${contact.email}`} className="text-sm text-zinc-400 hover:text-white block mt-2">{contact.email}</a>}
        </div>
      </div>
      <div className="border-t border-[#27272A] py-5 text-center text-xs text-zinc-500">
        © {year} Absolutely Business Entertainment. All Rights Reserved. Huntsville, AL
      </div>
    </footer>
  );
}
